export enum InitialScrollPosition {
  DEFAULT = 'DEFAULT',
  TOP = 'TOP',
  MIDDLE = 'MIDDLE',
  BOTTOM = 'BOTTOM',
}
